import script from "./DateElement.vue?vue&type=script&lang=js"
export * from "./DateElement.vue?vue&type=script&lang=js"

import "./DateElement.vue?vue&type=style&index=0&id=3aa84ab2&lang=scss"

const __exports__ = script;

export default __exports__